import React, { useEffect } from "react";
import qt from "@qt-base/jssdk";
import wxShare from "@qt-wx/share";
import "@qt-web/rem-standard";
import "@qt-web/css-common";
import { useRef } from "react";
import urlite from "urlite";
window.__BUILDER_PAGE_ID = '5eeb0972e308c07c9cf6901d';
const isInApp = qt.env.inApp;

const formatTime = time => {
  const newTime = new Date(time.replace(/-/g, '/'));
  return newTime;
};

const isExpire = endTime => {
  const currentTime = new Date();

  if (endTime) {
    const newEndTime = formatTime(endTime);

    if (currentTime > newEndTime) {
      return true;
    }
  }

  return false;
};

const isNotStart = startTime => {
  const currentTime = new Date();

  if (startTime) {
    const newStartTime = formatTime(startTime);

    if (currentTime < newStartTime) {
      return true;
    }
  }

  return false;
};

const getDisplayBlock = (startTime, endTime) => {
  let display = "block";

  if (endTime && isExpire(endTime) || startTime && isNotStart(startTime)) {
    display = 'none';
  }

  return display;
};

const getShareLink = () => {
  const url = window.location.href;
  return url;
};

const getHeight = () => {
  const winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  return winHeight;
};

const ContainerRender = ({
  basicConfig: basicConfig,
  containerConfig: containerConfig,
  children: children,
  id = "",
  nodeId = "",
  nodeType = ""
}) => {
  const shareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imageUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  };
  const wxShareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imgUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  }; //微信分享

  if (wxShare.isInWeixin) {
    wxShare.setShareConfig(wxShareConfig);
  }

  if (isInApp) {
    window.onPageAppear = async () => {
      await qt.page.setNavbar({
        show: true
      });
    };

    qt.page.setNavbar({
      hideShare: basicConfig.isHiddenAppShare
    });
    qt.page.setShare(shareConfig);
  }

  let inIosApp = qt.env.inIosApp;

  if (inIosApp) {
    window.addEventListener('hashchange', function () {
      qt.page.setShare(shareConfig);
    });
  }

  useEffect(() => {
    qt.monitor.bmsPageViewEntry({
      eventId: 'entry.componentContainer',
      nodeId,
      nodeType
    });
    document.title = basicConfig.title;
    document.body.style.fontSize = '16px';
    document.body.style.background = containerConfig.bgc;
    document.body.style.backgroundImage = containerConfig.bgimg;
    document.body.style.backgroundRepeat = 'repeat';
    document.getElementById('root').minHeight = window.innerHeight;

    if (inIosApp) {
      return window.removeEventListener('hashchange', () => {});
    }
  }, []);
  const {
    startTime,
    endTime,
    endTitle,
    beforeTitle,
    bgc,
    themeColor,
    bgimg,
    style,
    margin,
    padding
  } = containerConfig;
  const isExpireShow = isExpire(endTime);
  const tip = endTime && isExpireShow ? endTitle ? endTitle : '页面已过期~' : beforeTitle ? beforeTitle : '活动还未开始，敬请期待~';
  const display = getDisplayBlock(startTime, endTime);
  const currentStyle = {
    background: bgc,
    color: themeColor,
    minHeight: getHeight(),
    backgroundImage: `url(${bgimg})`,
    backgroundRepeat: 'repeat',
    margin,
    padding
  };
  const useStyle = Object.assign(currentStyle, style);
  return display === 'block' ? <div className="scroll-y" style={useStyle}>{children}</div> : <div style={{
    minHeight: getHeight(),
    display: 'flex',
    alignItems: 'center'
  }}>
        <div style={{
      textAlign: 'center',
      transform: 'translateY(-1rem)',
      width: '100%'
    }}>
            <div style={{
        width: '6rem',
        margin: '0 auto'
      }}><img style={{
          width: '100%'
        }} alt={'logo'} src={'https://pic.qingting.fm/activity/123/qtlogo.png'} /></div>
            <div style={{
        fontSize: '0.85rem',
        color: '#333',
        width: '100%',
        textAlign: 'center',
        paddingTop: '0.5rem'
      }}>{tip}</div>
        </div>
    </div>;
};

const TopicParagraph = ({
  id: id,
  content: content,
  config: config
}) => {
  const {
    common,
    style
  } = config;
  const {
    originImageSize
  } = common;
  const contentRef = useRef();
  useEffect(() => {
    const elem = contentRef.current;
    const archors = elem.querySelectorAll('a'); // == 锚链接拦截

    for (const archor of archors) {
      archor.addEventListener('click', e => {
        e.stopImmediatePropagation();
        e.preventDefault();
        const url = e.target.attributes.href.value;
        if (!url) return;
        const parsed = urlite.parse(url);

        if (parsed.pathname && !parsed.protocol) {
          const isQingtingProtocol = parsed.pathname.substr(0, 15) === 'app.qingting.fm';
          parsed.protocol = isQingtingProtocol ? 'qingtingfm:' : 'https:';
          window.location.href = urlite.format(parsed);
        } else {
          window.location.href = url;
        }
      });
    }
  }, []);
  return <div>
      {originImageSize ? <style>{`#paragraph-${id} img {width: auto;max-width: 100%;}`}</style> : null}
      <div id={`paragraph-${id}`} ref={contentRef} style={{
      fontSize: 14,
      lineHeight: 1.5714,
      ...style
    }} dangerouslySetInnerHTML={{
      __html: content
    }}></div>
    </div>;
};

export default (({}) => {
  const basicConfig = {
    title: "蜻蜓FM",
    shareTitle: "蜻蜓FM",
    shareImg: "https://sss.staging.qingting.fm/qt-builder-manage/upload_2bb66b65e93998005bb3751e72cb7f3b.png",
    shareSubTitle: "",
    shareLink: "",
    isHiddenAppShare: false
  };
  const containerConfig = {
    startTime: "",
    endTime: "",
    bgc: "#fff",
    themeColor: "#333",
    style: {},
    endTitle: "页面已过期~",
    beforeTitle: "活动还未开始，敬请期待~",
    bgimg: "",
    padding: "",
    margin: ""
  };
  const titleText = "蜻蜓FM举报受理和处置管理办法";
  const titleStyle = {
    textAlign: "center",
    fontSize: 18,
    color: "#333333",
    fontWeight: 700,
    lineHeight: 1
  };
  const marginStyle = {
    marginTop: 20,
    marginBottom: 20,
    marginLeft: 0,
    marginRight: 0
  };
  const topicParagraphContent = "<p>为保护公民、法人及其他组织合法权益，促进网上内容信息服务健康有序发展，营造清朗上网环境，根据相关法律法规，结合本网实际情况，特制定并公布本网举报受理和处置管理办法如下：</p><p><br></p><p><strong style=\"font-size: 14px;\">一、机构设置。</strong></p><p>网站总编室为本网违法和不良信息举报受理部门，网站值班小组、技术小组等部门协助完成举报信息处置工作。</p><p><strong style=\"font-size: 14px;\">二、举报信息受理范畴。</strong></p><p>在本网刊载的，具有如下性质的违法和不良信息：</p><p>（一）反对宪法所确定的基本原则的；</p><p>（二）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p><p>（三）损害国家荣誉和利益的；</p><p>（四）煽动民族仇恨、民族歧视，破坏民族团结的；</p><p>（五）煽动地域歧视、地域仇恨的；</p><p>（六）破坏国家宗教政策，宣扬邪教和封建迷信的；</p><p>（七）散布谣言，扰乱社会秩序，破坏社会稳定的；</p><p>（八）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p><p>（九）散布污言秽语，损害社会公序良俗的；</p><p>（十）侮辱或者诽谤他人，侵害他人合法权益的；</p><p>（十一）<span style=\"font-size: 14px; color: rgb(17, 31, 44);\">危害社会公德，损害民族优秀文化传统的；</span></p><p>（十二）<span style=\"font-size: 14px; color: rgb(17, 31, 44);\">存在未经合法授权或盗版情况，侵害他人知识产权（包括商标权、专利权、著作权/版权）的；</span></p><p>（十三）含有法律、行政法规禁止的其他内容的。</p><p><strong style=\"font-size: 14px;\">三、举报信息受理流程。</strong></p><p>网站设置24小时举报电话，值班人员负责接听举报电话并做好电话记录；网站设置举报邮箱，值班人员定期查看邮箱并整理记录；值班人员每日登录相关举报业务处理系统，查收转给本网站的举报信息并整理记录；以上记录均报送总编室，由总编室统筹受理。</p><p><strong style=\"font-size: 14px;\">四、举报信息处置流程。</strong></p><p>1、网站总编室根据举报信息，对举报内容进行细化分类、甄别核实。</p><p>2、对于属实的举报信息，上报分管领导，第一时间作出处置。举报处置完成后，及时向举报者反馈，无法反馈的予以注明。</p><p>3、针对来自相关举报业务处理系统的举报信息，根据举报业务处理系统操作规范，如实填写处理说明。</p><p>4、不属于本网站受理的举报信息，应当及时移送相关部门处理。</p><p>5、涉及危害国家安全、扰乱社会秩序等内容的重要举报信息，及时上报相关主管部门。</p><p>6、举报受理及处置过程中所形成的资料，应及时整理归档并做好保密工作。</p><p><br></p><p>违法和不良信息举报联系方式：</p><p>电话：021-64453178</p><p>邮箱：jubao@qingting.fm</p>";
  const topicParagraph = {
    common: {
      originImageSize: false
    },
    style: {
      marginTop: 10,
      marginBottom: 10,
      marginLeft: 15,
      marginRight: 15,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  return <ContainerRender id="f42" nodeId="c6503692-ea11-40c3-b4d4-914546c44f42" nodeType="component-container" containerConfig={containerConfig} basicConfig={basicConfig}><div id="402" nodeId="041853b5-e493-485a-b6d4-d79662da5402" nodeType="topic-title" style={{ ...titleStyle,
      ...marginStyle
    }}>{titleText}</div><TopicParagraph id="c0f" nodeId="a4a85b30-d859-4e69-85c4-a5742af45c0f" nodeType="topic-paragraph" content={topicParagraphContent} config={topicParagraph} /></ContainerRender>;
});